/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
const getHash = ()=>"object" !== "undefined" ? window.location.hash : undefined;
const useHash = ()=>{
    const [isClient, setIsClient] = useState(false);
    const [hash, setHash] = useState(getHash());
    const params = useParams();
    useEffect(()=>{
        setIsClient(true);
        setHash(getHash());
    }, [
        params
    ]);
    return isClient ? hash : null;
};
export default function HashRouter() {
    const hash = useHash();
    useEffect(()=>{
        if (!hash) return;
        const element = document.getElementById(hash.replace("#", ""));
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        hash
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {});
}
